export default "__VITE_ASSET__h4921ElT__"